export default __webpack_public_path__ + "static/img/google.d915ff3.svg";